import Header from '../../Components/Header'
import News from '../../Components/PageNews'

function NewsPage() {
    return (
        <div>
            <Header />
            <News/>
        </div>
    )
}

export default NewsPage